import { useEffect, useState } from 'react';
import { isSelectionPinned, type SelectionPin } from './paneVisibility';

// Records the list a selection was made in; isSelectionPinned covers the render before this catches up.
export function useSelectionPin(selectedKey: string | null, listScope: string): boolean {
    const [pin, setPin] = useState<SelectionPin>({ key: selectedKey, listScope });

    useEffect(() => {
        setPin((current) =>
            current.key === selectedKey ? current : { key: selectedKey, listScope }
        );
    }, [selectedKey, listScope]);

    return isSelectionPinned(pin, selectedKey, listScope);
}
